export interface FilterLoadFailure {
	cancel: () => void;
	retry: () => void;
}

export interface GridFilterFeedbackState {
	failures: ReadonlyMap<string, FilterLoadFailure>;
	refusal?: { colId: string; operation: "sort" | "filter" };
}

interface FeedbackStore {
	listeners: Set<() => void>;
	state: GridFilterFeedbackState;
}

const stores = new WeakMap<object, FeedbackStore>();
const getStore = (api: object): FeedbackStore => {
	let store = stores.get(api);
	if (!store) {
		store = { listeners: new Set(), state: { failures: new Map() } };
		stores.set(api, store);
	}
	return store;
};

const getGridFilterFeedback = (api: object): GridFilterFeedbackState => getStore(api).state;

const subscribeGridFilterFeedback = (api: object, listener: () => void): (() => void) => {
	const store = getStore(api);
	store.listeners.add(listener);
	return () => {
		store.listeners.delete(listener);
	};
};

const setFilterLoadFailure = (api: object, colId: string, failure?: FilterLoadFailure): void => {
	const store = getStore(api);
	const failures = new Map(store.state.failures);
	if (failure) failures.set(colId, failure);
	else failures.delete(colId);
	store.state = { ...store.state, failures };
	for (const listener of store.listeners) listener();
};

const notifyGridQueryRefusal = (api: object, refusal: NonNullable<GridFilterFeedbackState["refusal"]>): void => {
	const store = getStore(api);
	store.state = { ...store.state, refusal };
	for (const listener of store.listeners) listener();
};

const gridFilterFeedback = {
	getGridFilterFeedback,
	notifyGridQueryRefusal,
	setFilterLoadFailure,
	subscribeGridFilterFeedback
};

export default gridFilterFeedback;
